import { Button } from "components/atoms/Button"
import React from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"

const Outer = styled.div`
  width: 100%;
  height: 100vh;
  background-color: white;
`

const Inner = styled.div`
  padding: 6rem;
  text-align: center;
`

const StatusCode = styled.h1`
  font-size: 4rem;
`

const ButtonOuter = styled.div`
  padding: 4rem;
`
export const NotFound = () => {
  const navigate = useNavigate()
  return (
    <Outer>
      <Inner>
        <StatusCode>404</StatusCode>
        <div>
          ページが見つかりませんでした。
          <br />
          アクセスしているURLを再度お確かめください。
        </div>
        <ButtonOuter>
          <Button onClick={() => navigate("/")}>トップに戻る</Button>
        </ButtonOuter>
      </Inner>
    </Outer>
  )
}
